import { FC } from 'react';

import { Box, Stack } from '@mui/material';
import { Broadcast } from 'phosphor-react';

import { useNotifications } from '~components/hooks/notifications/useNotifications';
import { black, secondaryColors } from '~components/theme/styles/colors';
import { secondaryBox } from '~components/theme/styles/mixins';

export const AccountDialAnnouncementsBanner: FC = () => {
  const { notificationsComponents } = useNotifications();
  return (
    <Box sx={{ width: '100%' }}>
      <Stack
        direction={'row'}
        alignItems={'start'}
        justifyContent={'space-between'}
        borderRadius={2}
        zIndex={10}
        sx={{ ...secondaryBox, background: black['45%'], padding: '12px 16px' }}
        width={'100%'}
      >
        <Stack direction={'row'} width={'100%'} justifyContent={'space-between'}>
          <Stack direction={'row'}>
            <Box height={20} width={20} mr={2}>
              <Broadcast size={20} color={secondaryColors[200]} />
            </Box>

            {notificationsComponents[0]}
          </Stack>
        </Stack>
      </Stack>
    </Box>
  );
};
